
<date-range-picker 
                   (selectedDateRangeChanged)="onRangeChanged($event)" 
                   [options]="options"
                   [width]="width"
                   [imageSet]="imageSet"
                   >

</date-range-picker>